import { extent } from 'd3-array';
import { isUndefined } from 'lodash-es';

import { MinMax } from '../../core/types/min-max.js';
import { HoneycombTileNumericData } from '../types/honeycomb.js';

export const getDataExtent = (
  data: HoneycombTileNumericData[],
  minMaxConfig: Partial<MinMax> | undefined,
) => {
  const [dataMin, dataMax] = extent(data, (datum) => datum.value);
  if (isUndefined(minMaxConfig)) {
    return [dataMin, dataMax];
  } else {
    const { min: configMin, max: configMax } = minMaxConfig;
    const min = configMin ?? dataMin;
    const max = configMax ?? dataMax;
    return [min, max];
  }
};
